import AmberCopilotLogoSvg from "./AmberCopilotLogoSvg";

const AmberCopilotLogo = ({ width = 21, height = 21 }: { width?: number; height?: number }) => (
  <AmberCopilotLogoSvg width={width} height={height} />
);

export default AmberCopilotLogo;
